import React from 'react';
import NewsPostEditorComp from './NewsPostEditorComp';

function NewsPostEditor() {
  return <NewsPostEditorComp />;
}

export default NewsPostEditor;
